import { render, staticRenderFns } from "./FieldJoin.vue?vue&type=template&id=7fc50cef&scoped=true&"
import script from "./FieldJoin.vue?vue&type=script&lang=js&"
export * from "./FieldJoin.vue?vue&type=script&lang=js&"
import style0 from "./FieldJoin.vue?vue&type=style&index=0&id=7fc50cef&scoped=true&lang=css&"
import style1 from "./FieldJoin.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fc50cef",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VAvatar } from 'vuetify/lib/components/VAvatar';
installComponents(component, {VAutocomplete,VAvatar})
